import { render, staticRenderFns } from "./NeoTips.vue?vue&type=template&id=cacdc960&scoped=true&"
import script from "./NeoTips.vue?vue&type=script&lang=js&"
export * from "./NeoTips.vue?vue&type=script&lang=js&"
import style0 from "./NeoTips.vue?vue&type=style&index=0&id=cacdc960&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cacdc960",
  null
  
)

export default component.exports